// 后端微服务模块前缀
export const AUTH_SERVICE = "/auth-service";
export const SYSTEM_SERVICE = "/system-service";
export const FILE_SERVICE = "/file-service";
export const MESSAGE_SERVICE = "/message-service";
export const TASK_SERVICE = "/task-service";
export const DEV_SYSTEM = "/dev-system";
export const CLOUD_SYSTEM = "/cloud-system";
